{
  "moreActions": "المزيد من الإجراءات"
}
